export class firma{
    id?:number;
    idempresa?: number;
    fechacreacion?: Date;
    idrelacionado?: number;
    email?: string;
    idusuario?: number;
    terminoscondiciones?:boolean;
    firma?:string;
    fechaterminos?:Date;
    fecharenovacion?:Date;
    nombre?:string;
    cedula?:number;
    firmador?: string | null;
}